<template>
	<section>
		<div class="djcontainer" v-if="!hiddenTitle">
			<BaseHeading
				type="h5"
				class="mt-10 mb-7 relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
			>
				{{ $t("company.about") }}
			</BaseHeading>
		</div>
		<!-- About the company boxes -->
		<div class="masonrycontainer mb-10">
			<DjBoxTimeline
				v-if="companyData.boxes.history != undefined"
				:title="companyData.boxes.history.wizard_step.name[locale]"
				:data="companyData.boxes.history.data[locale]"
			/>
			<DjBoxMap
				v-if="companyData.boxes.address != undefined"
				:title="companyData.boxes.address.wizard_step.name[locale]"
				:address="companyData.boxes.address.data[0]"
				:other-addresses="companyData.boxes.address.data"
				:other-offices-text="$t('company.otherOffices')"
				:apiUrl="globalConfig.API"
				marker-url="https://res.cloudinary.com/djbs/image/upload/v1669709917/content/DreamJobs/Graphics/map_marker-dj.png"
			/>
			<DjBoxTags v-for="group in getProudOfGroups()" :key="group.key" :title="group.title" :tags="group.tags" />
			<DjBoxRte
				v-for="offering in getOfferings()"
				:key="offering.key"
				:title="$t('company.box.' + offering.titleKey)"
				:copy="offering.copy"
			/>
			<DjBoxPhotosWithLabel
				v-if="getClients() != false"
				:title="companyData.boxes.clients.wizard_step.name[locale]"
				:data="getClients()"
			/>
			<template
				v-if="companyData.boxes.product_video && Object.keys(companyData.boxes.product_video.data).length != 0"
			>
				<DjBoxVideo
					:title="companyData.boxes.product_video.wizard_step.name[locale]"
					:videoType="companyData.boxes.product_video.data.type"
					:videoId="companyData.boxes.product_video.data.video_id"
					:videoUrl="companyData.boxes.product_video.data.video"
				/>
			</template>
			<DjBoxPhotosWithLabel
				v-if="getBadges() != false"
				:title="$t('company.box.companyValues')"
				:data="getBadges()"
				bold-label
				borderless
			/>
			<DjBoxSocials :title="$t('company.box.followUs')" :socials="companyData.follow_us" />

			<!-- szmd boxes -->

			<template
				v-if="getSzmdBadges != false"
				v-for="getSzmdBadgesChunk in getSzmdBadges"
				:key="getSzmdBadgesChunk[0].label"
			>
				<DjBoxPhotosWithLabel
					v-if="getSzmdBadges != false"
					title=""
					:data="getSzmdBadgesChunk"
					bold-label
					borderless
				/>
			</template>
		</div>

		<div class="djcontainer">
			<BaseHeading
				v-if="
					companyData.boxes.quick_questions ||
					companyData.boxes.expert ||
					companyData.boxes.employee ||
					companyData.boxes.best_in_office ||
					companyData.boxes.office_photo ||
					companyData.boxes.quote ||
					companyData.boxes.best_tool ||
					companyData.boxes.properties ||
					companyData.boxes.famous_person ||
					companyData.boxes.team_video ||
					companyData.boxes.additional
				"
				type="h5"
				class="mt-10 mb-7 relative before:content-['&nbsp;'] before:block before:absolute before:-bottom-1 before:h-1 before:w-20 before:bg-red-500"
			>
				{{ $t("company.life") }}
			</BaseHeading>
		</div>

		<!-- Life with us boxes -->
		<div v-if="companyData.boxes" class="masonrycontainer mb-10">
			<template v-if="companyData.boxes.additional && Object.keys(companyData.boxes.additional.data).length != 0">
				<template
					v-for="(item, index) in companyData.boxes.additional.data.filter((i) => i.type === 'szmd-box-2025')"
					:key="index"
				>
					<template v-for="(boxitem, boxindex) in item.data" :key="boxindex">
						<DjBoxPhotoWithRteV2
							class="szmd-profile-box szmd-highlight pb-1"
							:title="$t('company.box.freeSzmdBox2025')"
							:photoId="item.data[boxindex].cloudinary"
						>
							<span v-html="transformSzmdText(item.data[boxindex].description[locale])"></span>
							<BaseLink
								v-if="szmdVotingInProgress"
								class="w-full mt-8 mb-3"
								:href="'/szmd/box-rating?slug=' + companyData.slug"
							>
								<BaseButton type="primary-red" class="w-full group">
									<BaseIcon
										class="mr-[10px] text-xl text-dj-red group-hover:hidden"
										icon="ic:outline-favorite-border"
										color="#fff"
									/>
									<BaseIcon
										class="mr-[10px] text-xl text-dj-red hidden group-hover:block"
										icon="ic:outline-favorite"
										color="#fff"
									/>
									{{ $t("szmdTexts.szmdBoxVoteCta") }}
								</BaseButton>
							</BaseLink>
						</DjBoxPhotoWithRteV2>
					</template>
				</template>
			</template>
			<template v-if="companyData.boxes.additional && Object.keys(companyData.boxes.additional.data).length != 0">
				<template v-for="(item, index) in companyData.boxes.additional.data" :key="index">
					<template v-if="item.type === 'respect'">
						<template v-for="(boxitem, boxindex) in item.data" :key="boxindex">
							<DjBoxPhotoWithRte
								:title="$t('company.box.respectBox')"
								:photoId="item.data[boxindex].cloudinary"
								:text="
									item.data[boxindex].description[locale].length
										? item.data[boxindex].description[locale]
										: ''
								"
							/>
						</template>
					</template>
				</template>
			</template>
			<template v-if="companyData.boxes.quick_questions && companyData.boxes.quick_questions.data.length != 0">
				<DjBoxQuickQuestions
					:title="companyData.boxes.quick_questions.wizard_step.name[locale]"
					:data="companyData.boxes.quick_questions.data[locale]"
				/>
			</template>
			<template v-if="companyData.boxes.expert && Object.keys(companyData.boxes.expert.data).length != 0">
				<DjBoxRte
					:title="companyData.boxes.expert.wizard_step.name[locale]"
					:copy="companyData.boxes.expert.data.text[locale]"
				/>
			</template>
			<template v-if="companyData.boxes.employee && Object.keys(companyData.boxes.employee.data).length != 0">
				<DjBoxRte
					:title="companyData.boxes.employee.wizard_step.name[locale]"
					:copy="companyData.boxes.employee.data.advice[locale]"
				/>
			</template>
			<template v-if="companyData.boxes.best_in_office && companyData.boxes.best_in_office.data.length != 0">
				<DjBoxRte
					:title="companyData.boxes.best_in_office.wizard_step.name[locale]"
					:copy="companyData.boxes.best_in_office.data[0].description[locale]"
				/>
			</template>
			<template v-if="companyData.boxes.office_photo && companyData.boxes.office_photo.data.length != 0">
				<DjBoxPhoto
					:title="companyData.boxes.office_photo.wizard_step.name[locale]"
					:photoAlt="companyData.boxes.office_photo.data[0].office"
					:photoId="companyData.boxes.office_photo.data[0].image.cloudinary"
				/>
			</template>
			<template
				v-if="
					companyData.boxes.quote &&
					Object.keys(companyData.boxes.quote.data).length != 0 &&
					Object.keys(companyData.boxes.quote.data.authortitle).length > 0
				"
			>
				<DjBoxQuote
					:title="companyData.boxes.quote.wizard_step.name[locale]"
					:text="companyData.boxes.quote.data.text[locale]"
					:authorPhotoId="
						companyData.boxes.quote.data.image != undefined
							? companyData.boxes.quote.data.image.cloudinary
							: ''
					"
					:author="companyData.boxes.quote.data.author[locale]"
					:authorTitle="
						String(companyData.boxes.quote.data.authortitle[locale]).length > 0
							? companyData.boxes.quote.data.authortitle[locale]
							: ''
					"
				/>
			</template>
			<template v-if="companyData.boxes.best_tool && companyData.boxes.best_tool.data.length != 0">
				<DjBoxPhoto
					:title="companyData.boxes.best_tool.wizard_step.name[locale]"
					:photoAlt="companyData.boxes.best_tool.data[0].office"
					:photoId="companyData.boxes.best_tool.data[0].image.cloudinary"
				/>
			</template>
			<template v-if="companyData.boxes.properties && Object.keys(companyData.boxes.properties.data).length != 0">
				<DjBoxRte
					:title="companyData.boxes.properties.wizard_step.name[locale]"
					:copy="companyData.boxes.properties.data.properties[locale]"
				/>
			</template>
			<template
				v-if="companyData.boxes.famous_person && Object.keys(companyData.boxes.famous_person.data).length != 0"
			>
				<DjBoxFamousPerson
					:title="companyData.boxes.famous_person.wizard_step.name[locale]"
					:photoUrl="companyData.boxes.famous_person.data.image"
					:name="companyData.boxes.famous_person.data.name"
					:text="companyData.boxes.famous_person.data.description[locale]"
				/>
			</template>
			<template v-if="companyData.boxes.team_video && Object.keys(companyData.boxes.team_video.data).length != 0">
				<DjBoxVideo
					:title="companyData.boxes.team_video.wizard_step.name[locale]"
					:videoType="companyData.boxes.team_video.data.type"
					:videoId="companyData.boxes.team_video.data.video_id"
					:videoUrl="companyData.boxes.team_video.data.video"
				/>
			</template>

			<BoxesShare v-if="hasSharingBox" />

			<template v-if="companyData.boxes.additional && Object.keys(companyData.boxes.additional.data).length != 0">
				<template v-for="(item, index) in companyData.boxes.additional.data" :key="index">
					<template v-if="item.type === 'image'">
						<DjBoxPhoto
							:title="
								item.data.boxtitle[locale] != '' && typeof item.data.boxtitle[locale] != 'object'
									? item.data.boxtitle[locale]
									: ''
							"
							:photo-alt="
								item.data.boxtitle[locale] != '' && typeof item.data.boxtitle[locale] != 'object'
									? item.data.boxtitle[locale]
									: 'box photo'
							"
							:photoId="item.data.cloudinary"
						/>
					</template>
					<template v-if="item.type === 'text'">
						<DjBoxRte :title="item.data.boxtitle[locale]" :copy="item.data.boxtext[locale]" />
					</template>
					<template
						v-if="
							item.type === 'quote' &&
							item.data &&
							item.data.text &&
							item.data.cloudinary &&
							item.data.author &&
							Object.keys(item.data.authortitle).length > 0
						"
					>
						<DjBoxQuote
							:text="item.data.text[locale]"
							:authorPhotoId="item.data.cloudinary"
							:author="item.data.author[locale]"
							:authorTitle="
								String(item.data.authortitle[locale]).length > 0 ? item.data.authortitle[locale] : ''
							"
						/>
					</template>
					<template v-if="item.type === 'article'">
						<DjBoxArticle
							:boxTitle="String(item.data.boxtitle[locale]).length > 0 ? item.data.boxtitle[locale] : ''"
							:url="item.data.url ? item.data.url[locale] : ''"
							:urlTitle="item.data.url_title ? item.data.url_title[locale] : ''"
							:apiUrl="globalConfig.API"
						/>
					</template>
					<template
						v-if="
							item.type === 'covid-19' || item.type === 'new-normal' || item.type === 'digital-solutions'
						"
					>
						<template v-for="(boxitem, boxindex) in item.data" :key="boxindex">
							<DjBoxPhotoWithRte
								:title="
									item.type === 'covid-19'
										? $t('company.box.freeCovidBox')
										: item.type === 'new-normal'
										? $t('company.box.freeNewNormalBox')
										: item.type === 'digital-solutions'
										? $t('company.box.freeDigitalSolutions')
										: ''
								"
								:photoId="item.data[boxindex].cloudinary"
								:text="
									item.data[boxindex].description[locale].length
										? item.data[boxindex].description[locale]
										: ''
								"
							/>
						</template>
					</template>
					<template v-if="item.type === 'video'">
						<DjBoxVideo
							:title="item.data.boxtitle[locale]"
							:videoType="item.data.type"
							:videoId="item.data.video_id"
							:videoUrl="item.data.video"
						/>
					</template>
				</template>
			</template>
		</div>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { textTransformService, TransformationType, TransformationConfig } from "~/services/TextTransformService";

export default defineComponent({
	name: "CompanyProfileBoxes",
	props: {
		companyData: {
			type: Object,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
		hiddenTitle: {
			type: Boolean,
			default: false,
		},
		hasSharingBox: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const region = ref("");
		const config = useRuntimeConfig().public;
		const mapsApiKey = config.googleMaps.apiKey;
		const { t, locale } = useI18n();
		const getSzmdBadges = calcSzmdBadges();
		const { szmdVotingInProgress } = useSzmdConfig();

		function getOfferings() {
			const data = props.companyData?.boxes?.product?.data;
			if (!data) {
				return [];
			}

			const nested = Boolean(data.product || data.service);
			const offerings = nested
				? ["product", "service"].map((key) => ({ key, row: data[key] }))
				: [{ key: "product", row: { name: data.name, description: data.description } }];

			return offerings.flatMap(({ key, row }) => {
				if (!row) {
					return [];
				}

				const name = row.name?.[props.locale] || "";
				const description = row.description?.[props.locale] || "";
				if (!name && !description) {
					return [];
				}

				const heading = name ? `<h4><strong>${name}</strong></h4><br />` : "";
				return [
					{
						key,
						titleKey: key === "product" ? "ourProduct" : "ourService",
						copy: `${heading}${description}`,
					},
				];
			});
		}

		function getProudOfGroups() {
			const tags = props.companyData?.tags?.tag?.data;
			if (!Array.isArray(tags) || tags.length === 0 || !props.companyData?.boxes?.proud_of?.wizard_step) {
				return [];
			}

			const localeName = (tag) => tag.name[props.locale];
			const grouping = props.companyData.boxes.proud_of.data || {};
			const productIds = Array.isArray(grouping.product) ? grouping.product : [];
			const serviceIds = Array.isArray(grouping.service) ? grouping.service : [];
			const hasGrouping = productIds.length > 0 || serviceIds.length > 0;

			if (!hasGrouping) {
				return [
					{
						key: "all",
						title: props.companyData.boxes.proud_of.wizard_step.name[props.locale],
						tags: tags.map(localeName),
					},
				];
			}

			const byId = new Map(tags.map((tag) => [Number(tag.id), tag]));
			const namesFor = (ids) =>
				ids
					.map((id) => byId.get(Number(id)))
					.filter(Boolean)
					.map(localeName);

			let productTags = namesFor(productIds);
			let serviceTags = namesFor(serviceIds);
			const used = new Set([...productIds, ...serviceIds].map(Number));
			const leftovers = tags.filter((tag) => !used.has(Number(tag.id))).map(localeName);
			const hasProductOffering = Boolean(
				props.companyData.boxes.product?.data?.product || props.companyData.boxes.product?.data?.name
			);
			const hasServiceOffering = Boolean(props.companyData.boxes.product?.data?.service);

			if (hasProductOffering || !hasServiceOffering) {
				productTags = productTags.concat(leftovers);
			} else {
				serviceTags = serviceTags.concat(leftovers);
			}

			if (productTags.length && serviceTags.length) {
				return [
					{ key: "product", title: t("company.box.proudOfProduct"), tags: productTags },
					{ key: "service", title: t("company.box.proudOfService"), tags: serviceTags },
				];
			}

			return [
				{
					key: "all",
					title: props.companyData.boxes.proud_of.wizard_step.name[props.locale],
					tags: productTags.concat(serviceTags),
				},
			];
		}

		function getClients() {
			if (Array.isArray(props.companyData?.boxes?.clients?.data)) {
				return props.companyData.boxes.clients.data.map((client) => {
					return {
						url: client.cloudinary,
						label: "",
					};
				});
			} else {
				return false;
			}
		}

		function getBadges() {
			if (props.companyData.badges.length != 0) {
				return props.companyData.badges.map((badge) => {
					return {
						url: badge.image.cloudinary,
						label: badge.name[props.locale],
					};
				});
			} else {
				return false;
			}
		}

		function calcSzmdBadges() {
			const cloudinaryServer = locale.value == "hu" ? "v1669883156" : "v1669708826";
			const imageNamePostfix = locale.value == "hu" ? "-hu" : "-en";

			if (props.companyData.szmd_years.length != 0) {
				let returnValue = props.companyData.szmd_years.map((year) => {
					return {
						url: `${cloudinaryServer}/content/DreamJobs/Graphics/SZMD${year}_award${imageNamePostfix}.png`,
						label: t("szmdWinner") + " " + year,
						postfix: "",
					};
				});

				// Chunk array to 6 items. 6 item / box
				const chunkedArray = [];
				for (let i = 0; i < returnValue.length; i += 6) {
					chunkedArray.push(returnValue.slice(i, i + 6));
				}
				return chunkedArray;
			} else {
				return false;
			}
		}

		function transformSzmdText(szmdText: string | null | undefined): string {
			if (!szmdText?.length) {
				return "";
			}

			const transformConfigs: TransformationConfig[] = [
				{
					type: TransformationType.LINE_BREAKS,
				},
				{
					type: TransformationType.YOUTUBE_LINKS,
				},
				{
					type: TransformationType.URL_TO_LINKS,
					options: {
						className: "text-dj-blue",
					},
				},
			];

			return textTransformService.transform(szmdText, transformConfigs);
		}

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
		});

		return {
			transformSzmdText,
			getOfferings,
			getProudOfGroups,
			getClients,
			getBadges,
			getSzmdBadges,
			region,
			mapsApiKey,
			szmdVotingInProgress,
		};
	},
	mounted() {
		// TODO - Remove when the box sorting development is completed
		if (window.location.pathname.includes("/avis-budget-group-bsc")) {
			const elementList = document.querySelectorAll(".masonrycontainer H3");
			const insertArea = document.querySelector(".masonrycontainer");
			if (!insertArea) {
				return;
			}

			for (const element of elementList) {
				if (
					element.innerHTML == "Szerethető Példakép Munkahely 2024" ||
					element.innerHTML == "Role Model Workplace 2024"
				) {
					const clonedNode = element.parentElement.cloneNode(true);

					insertArea.insertBefore(clonedNode, insertArea.firstChild);
					break;
				}
			}
		}
	},
});
</script>

<style lang="css">
.szmd-profile-box.szmd-highlight {
	border-width: 0;
	outline: 2px solid #f17e90;
	outline-offset: -2px;
}
</style>
